import React, { useMemo } from 'react';

import { LumberListPrototype } from '@paragon/contract-library';

import { NavigationBreadcrumbsBase } from './NavigationBreadcrumbsBase';

interface Props {
  lumberList: LumberListPrototype | null;
}

export function LumberListBreadcrumbs({ lumberList }: Props) {
  const crumbs = useMemo(
    (): [string, string][] => [
      ['Home', '/'],
      ['Lumber Lists', '/'],
      [lumberList?.name ?? '', `/lumberLists/${lumberList?.guid}`],
    ],
    [lumberList],
  );

  return <NavigationBreadcrumbsBase crumbs={crumbs} />;
}
